import type { FolderDto } from '@mimir/common/dto/folderModels';
import type { ItemAccessControl } from '@mimir/common/dto/itemAccessControlDto';
import type { ClientItem } from '@mimir/common/dto/searchResultHit';
import type { SearchItemType } from '@mimir/common/dto/itemTypes';

export enum MovementStatus {
  PENDING = 'pending',
  LOADING = 'loading',
  OK = 'success',
  ERROR = 'error'
}

export interface MovementRequest {
  id: string;
  status: MovementStatus;
  name: string;
  targetFolder: {
    id: string;
    name: string;
    visibleTo?: ItemAccessControl | undefined;
  };
  type: SearchItemType;
  errorMessage: string | null;
  item?: ClientItem | FolderDto;
}
